import { render, staticRenderFns } from "./WidgetStat.vue?vue&type=template&id=781f8fa1"
import script from "./WidgetStat.vue?vue&type=script&lang=js"
export * from "./WidgetStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports